"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _component = require("../component");

var _styles = require("../styles");

var _cleanProps = _interopRequireDefault(require("../utils/cleanProps"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var Textarea =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(Textarea, _PureComponent);

  function Textarea(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.state = {
      height: 0
    };
    _this.bindShadow = _this.bindShadow.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleKeyUp = _this.handleKeyUp.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.resize = _this.resize.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = Textarea.prototype;

  _proto.componentDidMount = function componentDidMount() {
    _PureComponent.prototype.componentDidMount.call(this);

    if (this.props.autosize) this.resize();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.autosize && prevProps.value !== this.props.value) this.resize(this.props.value);
  };

  _proto.bindShadow = function bindShadow(el) {
    this.shadow = el;
  };

  _proto.resize = function resize(value) {
    if (value || value === '') this.shadow.value = value;
    var height = this.shadow ? this.shadow.scrollHeight : 0;
    this.setState({
      height: height
    });
  };

  _proto.handleChange = function handleChange(e) {
    this.props.onChange(e.target.value);

    if (this.props.autosize) {
      this.resize(e.target.value);
    }
  };

  _proto.handleKeyUp = function handleKeyUp(e) {
    var onEnterPress = this.props.onEnterPress;

    if (e.keyCode === 13 && onEnterPress) {
      onEnterPress(e.target.value, e);
    }
  };

  _proto.handleBlur = function handleBlur(e) {
    var value = e.target.value;
    var _this$props = this.props,
        forceChange = _this$props.forceChange,
        onBlur = _this$props.onBlur;
    if (onBlur) onBlur(e);
    forceChange(value);
  };

  _proto.renderInfo = function renderInfo() {
    var info = this.props.info;
    if (typeof info !== 'function') return null;
    var res = info(this.props.value); // empty

    if (!res) return null;
    var isError = res instanceof Error;
    var text = isError ? res.message : res;
    return _react.default.createElement("div", {
      key: "info",
      style: {
        minWidth: 'auto'
      },
      className: (0, _styles.inputClass)('bottom-right', isError ? 'error' : 'tip')
    }, text);
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        autosize = _this$props2.autosize,
        onChange = _this$props2.onChange,
        maxHeight = _this$props2.maxHeight,
        info = _this$props2.info,
        onEnterPress = _this$props2.onEnterPress,
        props = _objectWithoutPropertiesLoose(_this$props2, ["autosize", "onChange", "maxHeight", "info", "onEnterPress"]);

    var value = props.value == null ? '' : props.value;
    var height = this.state.height || 'auto';
    var className = autosize ? (0, _styles.inputClass)('auto-size') : '';
    var ts = [_react.default.createElement("textarea", _extends({}, (0, _cleanProps.default)(props), {
      key: "t",
      value: value,
      className: className,
      style: {
        height: height,
        maxHeight: maxHeight,
        overflow: 'auto'
      },
      onChange: this.handleChange,
      onKeyUp: this.handleKeyUp,
      onBlur: this.handleBlur
    })), this.renderInfo()];

    if (autosize) {
      ts.push(_react.default.createElement("textarea", {
        key: "s",
        ref: this.bindShadow,
        className: (0, _styles.inputClass)('shadow'),
        rows: props.rows,
        defaultValue: value
      }));
    }

    return ts;
  };

  return Textarea;
}(_component.PureComponent);

Textarea.propTypes = {
  autosize: _propTypes.default.bool,
  forceChange: _propTypes.default.func,
  info: _propTypes.default.func,
  maxHeight: _propTypes.default.number,
  onBlur: _propTypes.default.func,
  onChange: _propTypes.default.func.isRequired,
  onEnterPress: _propTypes.default.func,
  rows: _propTypes.default.number,
  value: _propTypes.default.string
};
Textarea.defaultProps = {
  rows: 4
};
var _default = Textarea;
exports.default = _default;